import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { ContactComponent } from './contact/contact.component';
import { HomeComponent } from './home/home.component';
import { ScheduleDemoComponent } from './schedule-demo/schedule-demo.component';
import { PartnerComponent } from './partner/partner.component';
import { CampaignComponent } from './campaign/campaign.component';
import { ResourcesComponent } from './resources/resources.component';
import { PostsComponent } from './posts/posts.component';
import { PocDetailComponent } from './poc-detail/poc-detail.component';
import { CoursePackageComponent } from './course-package/course-package.component';
import { WebinarComponent } from './webinar/webinar.component';
import { EventsComponent } from './events/events.component';

const routes: Routes = [
  {path:"",component:HomeComponent },
  {path:"contact",component:ContactComponent },
  {path:"schedule-demo",component:ScheduleDemoComponent },
  {path:"partner", component: PartnerComponent},
  {path:"campaign", component: CampaignComponent},
  {path:"library/:slug", component: PocDetailComponent},
  {path:"resources", children:[    
    { path: ':id', component: ResourcesComponent },
    { path: '', component: ResourcesComponent },
    { path: ':id/:post', component: PostsComponent },
  ]},
  {path:"forindividual", component: CoursePackageComponent },
  {path:"events", children:[
    {path:':slug', component: WebinarComponent},
    {path:'', component: EventsComponent}
  ]},
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
